import { useState } from 'react'
import { RiStarFill, RiStarLine } from 'react-icons/ri'
import { GOLD } from '../constants.js'

export default function StarRating({ value, onChange, readOnly = false, size = 'sm' }) {
  const [hover, setHover] = useState(0)
  const cls = size === 'xs' ? 'text-xs' : 'text-base'

  return (
    <div className="inline-flex items-center gap-0.5">
      {Array.from({ length: 5 }, (_, i) => {
        const star = i + 1
        const filled = (hover || value) >= star
        return (
          <button
            key={i}
            type="button"
            disabled={readOnly}
            className={`${cls} transition-colors ${readOnly ? 'cursor-default' : 'cursor-pointer'}`}
            style={{ color: filled ? GOLD : 'rgb(209 213 219)' }}
            onClick={() => !readOnly && onChange?.(star)}
            onMouseEnter={() => !readOnly && setHover(star)}
            onMouseLeave={() => !readOnly && setHover(0)}
            aria-label={readOnly ? `${value} bintang` : `Beri ${star} bintang`}
          >
            {filled ? <RiStarFill /> : <RiStarLine />}
          </button>
        )
      })}
    </div>
  )
}
